import { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { IUiMultiSelectProps } from '../../model/types';

interface IUseMultiSelect {
    needSearch?: IUiMultiSelectProps['needSearch'];
}

export const useMultiSelect = ({ needSearch }: IUseMultiSelect) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const searchRef = useRef<HTMLInputElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isOpen && needSearch && searchRef.current) {
            searchRef?.current?.focus();
        }
    }, [isOpen, needSearch]);

    useEffect(() => {
        if (isOpen) {
            const handleClickOutside = (e: MouseEvent) => {
                if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
                    setIsOpen(false);
                }
            };

            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
        return undefined;
    }, [isOpen]);

    const onContainerClick = () => {
        setIsOpen(!isOpen);
    };
    return {
        onContainerClick,
        isOpen,
        searchRef,
        containerRef,
        t,
    };
};
